import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';


const resources = {
  es: {
    translation: {
      "coemeterium": "COEMETERIUM",
      "ourServices": "Nuestros Servicios y Productos",
      "name": "Nombre",
      "lastName": "Apellido",
      "services": "Servicios",
      "navigate": "Navegar / Ruta hasta...",
      "visitBurial": "Visitar sepultura",
      "loading": "Cargando....",
      "confirmacionTitle": "Confirmación de servicios",
      "difuntoInfo": "Información del difunto",
      "selectedItems": "Has seleccionado los siguientes elementos:",
      "thankYouMessage": "¡Gracias por tu solicitud! Nos pondremos en contacto contigo pronto.",
      "backButton": "Editar",
      "birthDate": "Fecha de nacimiento",
      "deathDate": "Fecha de defunción",
      "dd": "DD",
      "mm": "MM",
      "yyyy": "AAAA",
      "restart": "Reiniciar", 
      "alertTitle": "Información Importante",
      "alertButton": "Entendido",
      "noSelectionAlert": "Por favor, seleccione un apellido y nombre para continuar.",
      "routeFoundAlert": "Se ha encontrado la ruta. Ver mapa.",
      "noRouteFoundAlert": "No se ha encontrado la ubicación para la persona seleccionada.",
      "continuePayment": "Proceder al pago",
      "total": "Total",

      // --- SERVICIOS ---
      "selectionInstruction": "*Para seleccionar o deseleccionar flores deberá hacer doble click a la imagen",
      "sectionFlowers": "Flores y Arreglos",
      "descFlowers": "Variedad de arreglos florales y homenajes para cada ocasión.",
      "sectionCleaning": "Servicios de Limpieza",
      "descCleaning": "Mantenimiento y limpieza de lápidas y monumentos.",
      "optCleaning": "Sí, quiero el servicio de limpieza y mantenimiento",
      "optCleaningShort": "Limpieza y mantenimiento",
      "sectionCustom": "Servicios Personalizados",
      "descCustom": "Reparaciones y arreglos especiales.",
      "customNote": "Nota: Estos servicios requieren de un presupuesto personalizado que le será enviado por correo electrónico.",
      "itemSelected": "artículo seleccionado",
      "itemsSelected": "artículos seleccionados",
      "noItemsSelected": "Ningún artículo seleccionado",
      "closeButton": "Cancelar",
      "continueButton": "Continuar",

      // --- CONFIRMACIÓN ---
      "confirmacionSolicitud": "Confirmación de solicitud",
      "datosDifunto": "Datos del difunto :",
      "productosTitle": "Productos",
      "serviciosTitle": "Servicios",
      "noItemsError": "No se han seleccionado elementos. Por favor, regresa y selecciona algunos servicios.",
      "priceConfirmEmail": "Se le enviará un correo electrónico para confirmar el precio",

      // --- PASARELA DE PAGO ---
      "pasarelaTitle": "Pasarela de Pago",
      "personalDetails": "Datos Personales",
      "paymentInfo": "Información de Pago",
      "labelNombre": "Nombre *",
      "labelApellidos": "Apellidos *",
      "labelEmail": "Correo Electrónico *",
      "labelEmailConfirm": "Confirmar Correo Electrónico *",
      "labelPhone": "Teléfono (Opcional)",
      "labelCardNumber": "Nº Tarjeta *",
      "labelExpiry": "Caducidad *",
      "labelCVV": "CVV *",
      "cancelButton": "Cancelar",
      "payNowButton": "Pagar Ahora",
      "placeholderCard": "0000 0000 0000 0000",
      "placeholderCVV": "123",
      "errorNombre": "El nombre es obligatorio.",
      "errorApellidos": "Los apellidos son obligatorios.",
      "errorEmail": "El correo es obligatorio.",
      "errorEmailConfirm": "La confirmación de correo es obligatoria.",
      "errorEmailInvalid": "Correo inválido.",
      "errorEmailsMismatch": "Los correos electrónicos no coinciden.",
      "errorCardInvalid": "Nº tarjeta inválido (16 dígitos).",
      "errorCVVInvalid": "CVV inválido (3 dígitos).",
      "paymentSuccess": "Pago realizado con éxito (Simulación)",

      // --- ALERTAS GLOBALES ---
      "noMorePhotos": "Lo sentimos no hay mas imagenes disponibles",
      "selectPersonFirst": "Por favor, selecciona a la persona antes de continuar.",
      "selectAtLeastOne": "Por favor, selecciona al menos una imagen para continuar.",
      "logout": "Cerrar Sesión",
      "repairGrave": "Reparación de la sepultura",
      "fixTexts": "Arreglo de textos",
      "palma1": "Palma 1",
      "palma2": "Palma 2",
      "palma3": "Palma 3",
      "homenaje1": "Homenaje 1",
      "homenaje2": "Homenaje 2",
      "homenaje3": "Homenaje 3",
      "jarron1": "Jarrón 1",
      "jarron2": "Jarrón 2",
      "placeholderPhone": "Nº Teléfono",
      "placeholderPrefix": "Prefijo",
      "brandIconAlt": "Icono de COEMETERIUM",
      "countrySpain": "España",
      "countryUSA": "USA",
      "countryUK": "UK",
      "countryFrance": "Francia",
      "countryGermany": "Alemania",
      "errorAllFields": "Todos los campos deben estar completos",
      "Anterior": "Anterior",
      "Siguiente": "Siguiente",
      "datesMismatch": "Las fechas ingresadas no coinciden con las de la persona seleccionada.",
      "layerPointsOfInterest": "Puntos de interés",
      "layerHowToGetThere": "Como llegar",
      "layerBusRoute110": "Recorrido bus Linea 110",
      "layerGeneralInfo": "Información general",
      "layerNichesColumbariums": "Nichos y Columbarios"
    }
  },
  en: {
    translation: {
      "coemeterium": "COEMETERIUM",
      "ourServices": "Our Services and Products",
      "name": "Name",
      "lastName": "Last Name",
      "services": "Services",
      "navigate": "Navigate / Route to...",
      "visitBurial": "Visit Grave",
      "loading": "Loading....",
      "confirmacionTitle": "Services Confirmation",
      "difuntoInfo": "Deceased's Information",
      "selectedItems": "You have selected the following items:",
      "thankYouMessage": "Thank you for your request! We will contact you soon.",
      "backButton": "Edit",
      "birthDate": "Date of birth",
      "deathDate": "Date of death",
      "dd": "DD",
      "mm": "MM",
      "yyyy": "YYYY",
      "restart": "Restart",
      "alertTitle": "Important Information",
      "alertButton": "Got it",
      "noSelectionAlert": "Please select a last name and name to continue.",
      "routeFoundAlert": "Route found. See map.",
      "noRouteFoundAlert": "Location not found for the selected person.",
      "continuePayment": "Continue to Payment",
      "total": "Total",

      // --- SERVICIOS ---
      "selectionInstruction": "*To select or deselect flowers, double-click the image",
      "sectionFlowers": "Flowers and Arrangements",
      "descFlowers": "Variety of floral arrangements and tributes for every occasion.",
      "sectionCleaning": "Cleaning Services",
      "descCleaning": "Maintenance and cleaning of tombstones and monuments.",
      "optCleaning": "Yes, I want the cleaning and maintenance service",
      "optCleaningShort": "Cleaning and maintenance",
      "sectionCustom": "Custom Services",
      "descCustom": "Special repairs and arrangements.",
      "customNote": "Note: These services require a personalized quote that will be sent to you by email.",
      "itemSelected": "item selected",
      "itemsSelected": "items selected",
      "noItemsSelected": "No items selected",
      "closeButton": "Cancel",
      "continueButton": "Continue",

      // --- CONFIRMACIÓN ---
      "confirmacionSolicitud": "Request Confirmation",
      "datosDifunto": "Deceased details:",
      "productosTitle": "Products",
      "serviciosTitle": "Services",
      "noItemsError": "No items selected. Please go back and select some services.",
      "priceConfirmEmail": "An email will be sent to you to confirm the price",

      // --- PASARELA DE PAGO ---
      "pasarelaTitle": "Payment Gateway",
      "personalDetails": "Personal Details",
      "paymentInfo": "Payment Information",
      "labelNombre": "First Name *",
      "labelApellidos": "Last Names *",
      "labelEmail": "Email Address *",
      "labelEmailConfirm": "Confirm Email Address *",
      "labelPhone": "Phone (Optional)",
      "labelCardNumber": "Card Number *",
      "labelExpiry": "Expiry *",
      "labelCVV": "CVV *",
      "cancelButton": "Cancel",
      "payNowButton": "Pay Now",
      "placeholderCard": "0000 0000 0000 0000",
      "placeholderCVV": "123",
      "errorNombre": "First name is required.",
      "errorApellidos": "Last names are required.",
      "errorEmail": "Email is required.",
      "errorEmailConfirm": "Email confirmation is required.",
      "errorEmailInvalid": "Invalid email.",
      "errorEmailsMismatch": "Emails do not match.",
      "errorCardInvalid": "Invalid card number (16 digits).",
      "errorCVVInvalid": "Invalid CVV (3 digits).",
      "paymentSuccess": "Payment successful (Simulation)",

      // --- ALERTAS GLOBALES ---
      "noMorePhotos": "Sorry, no more images available",
      "selectPersonFirst": "Please select the person before continuing.",
      "selectAtLeastOne": "Please select at least one image to continue.",
      "logout": "Logout",
      "repairGrave": "Grave repair",
      "fixTexts": "Text fixing",
      "palma1": "Palm Arrangement 1",
      "palma2": "Palm Arrangement 2",
      "palma3": "Palm Arrangement 3",
      "homenaje1": "Tribute 1",
      "homenaje2": "Tribute 2",
      "homenaje3": "Tribute 3",
      "jarron1": "Vase 1",
      "jarron2": "Vase 2",
      "placeholderPhone": "Phone Number",
      "placeholderPrefix": "Prefix",
      "brandIconAlt": "COEMETERIUM Icon",
      "countrySpain": "Spain",
      "countryUSA": "USA",
      "countryUK": "UK",
      "countryFrance": "France",
      "countryGermany": "Germany",
      "errorAllFields": "All fields must be completed",
      "Anterior": "Previous",
      "Siguiente": "Next",
      "datesMismatch": "The entered dates do not match those of the selected person.",
      "layerPointsOfInterest": "Points of Interest",
      "layerHowToGetThere": "How to get there",
      "layerBusRoute110": "Bus Route 110",
      "layerGeneralInfo": "General Information",
      "layerNichesColumbariums": "Niches and Columbariums"
    }
  }
};

i18n

  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', 
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;